import NiceModal, { useModal } from '@ebay/nice-modal-react';

// Import styles
import { AntModalStyled, ModalContent, StyledTitle } from 'components/views/offer_configurator/components/common/modals/styles';
import { List } from './styles';

// Import components
import { ModalCloseButton } from 'components/views/offer_configurator/components/common/modals/components/ModalCloseButton';
import { Channel } from './Channel';

// Import types
import type { ChannelWithEpg } from 'types/views/epg';
import type { ChannelInList } from 'types/api/products/channels';
import type { PacketChannel } from 'types/api/products/packet/products';

type Props = {
	channels: Array<ChannelWithEpg | ChannelInList | PacketChannel>;
	title: string | null;
};

export const ChannelsModal = NiceModal.create(({ channels, title }: Props) => {
	const { visible, remove } = useModal();

	return (
		<AntModalStyled visible={visible} closable={false} footer={null} centered>
			<ModalCloseButton closeModal={remove} />
			<ModalContent maxWidth="100%" gap={3.9}>
				<StyledTitle>{title}</StyledTitle>

				<List>
					{channels.map((channel) => (
						<Channel key={channel.uuid} title={channel.title} images={channel.images} />
					))}
				</List>
			</ModalContent>
		</AntModalStyled>
	);
});
